export default __webpack_public_path__ + "static/media/Margherita.84062db1.jpeg";